import { useEffect } from "react";

const PROD_ORIGIN = "https://demkabiz.com";
const DEFAULT_OG_IMAGE = `${PROD_ORIGIN}/og-image.jpg`;
const DEFAULT_DESC = "DemkaBiz — Les services d'établissement et d'entrepreneuriat en un seul clic. Plateforme francophone pour nouveaux arrivants, professionnels, entrepreneurs et organismes au Canada.";

/**
 * Lightweight SEO hook — sets document.title, meta tags, OG and Twitter card per page.
 * Always points canonical/OG URL to the production domain (demkabiz.com) regardless of
 * the current host, so social previews remain consistent even from preview environments.
 */
export default function useSEO({ title, description, ogImage } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | DemkaBiz` : "DemkaBiz — S'établir. Entreprendre. Réussir.";
    const desc = description || DEFAULT_DESC;
    const image = ogImage || DEFAULT_OG_IMAGE;
    const canonicalUrl = `${PROD_ORIGIN}${window.location.pathname}`;

    document.title = fullTitle;

    setMeta("name", "description", desc);

    setMeta("property", "og:site_name", "DemkaBiz");
    setMeta("property", "og:locale", "fr_CA");
    setMeta("property", "og:type", "website");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", canonicalUrl);
    setMeta("property", "og:image", image);
    setMeta("property", "og:image:alt", "Logo DemkaBiz");

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", image);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalUrl);
  }, [title, description, ogImage]);
}

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
